import React, { Component } from 'react';
import Slider from '../../../../Part_Sample/Slider';
import { isEmpty } from '../../../../Common/Common';

export default class Av_Slider extends Component {
	constructor(props) {
		super(props);

		let av = 0
		if (!isEmpty(this.props.point_info)) {
			av = this.props.point_info.av
		}

		this.state = {
			av: av,
		}
	}

	handleChangeAV = (val) => {
		val = parseFloat(val)
		this.setState({ av: val })
		this.props.handleChangeVal(parseFloat(val));
	}

	render() {
		let min = 0;
		let max = 100;
		let step = 1;
		let unit = '';

		if (!isEmpty(this.props.point_info)) {
			min = this.props.point_info.limit[0];
			max = this.props.point_info.limit[1];
			step = 1 / (Math.pow(10, this.props.point_info.ndp));
			unit = this.props.point_info.unit
		}

		return (
			<div id='slider' style={{ cursor: 'pointer', textAlign: 'left' }}>
				<div style={{ marginTop: 20, marginBottom: 20 }}>
					<div style={{ display: 'inline-block', marginLeft: 20, width: (this.props.width - 40) / 2 }}>
						<span >{this.props.receiver.getString('av')}</span>
					</div>
					<div style={{ display: 'inline-block', marginRight: 20, width: (this.props.width - 40) / 2, textAlign: 'right' }}>
						<span >{this.state.av}{unit}</span>
					</div>
				</div>
				<div style={{ width: this.props.width - 100, marginLeft: 'auto', marginRight: 'auto' }}>
					<Slider
						style={{ width: '100%', display: 'inline-block', maxWidth: 'unset' }}
						value={this.state.av}
						min={min}
						max={max}
						step={step}
						handleChangeSliderVal={this.handleChangeAV} />
				</div>
				<div style={{ width: this.props.width - 60, marginLeft: 'auto', marginRight: 'auto', marginTop: 10 }}>
					<div style={{ width: '50%', textAlign: 'left', display: 'inline-block', }}>
						<span>{min}</span>
					</div>
					<div style={{ width: '50%', textAlign: 'right', display: 'inline-block', }}>
						<span>{max}</span>
					</div>
				</div>
			</div>
		)
	}
}